import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { ShieldAlert, Radio } from "lucide-react";

export function ProviderPanel({
  providers,
  enabled,
  onToggle,
  onToggleAll,
  hideDead,
  onHideDead,
}) {
  const allOn = providers.length > 0 && providers.every((p) => enabled.has(p.id));

  return (
    <div className="rounded-lg border border-neutral-800 bg-neutral-900/40">
      <div className="flex items-center justify-between px-4 py-3 border-b border-neutral-800">
        <div className="flex items-center gap-2">
          <Radio size={14} className="text-cyan-400" />
          <h2 className="text-[11px] font-mono uppercase tracking-[0.2em] text-neutral-400">
            Providers
          </h2>
        </div>
        <button
          data-testid="toggle-all-providers"
          onClick={() => onToggleAll(!allOn)}
          className="text-[10px] font-mono uppercase tracking-wider text-cyan-400 hover:text-cyan-300 transition-colors"
        >
          {allOn ? "None" : "All"}
        </button>
      </div>

      <div className="divide-y divide-neutral-800/60">
        {providers.map((p) => (
          <label
            key={p.id}
            data-testid={`provider-item-${p.id}`}
            className="flex items-center justify-between gap-3 px-4 py-3 cursor-pointer hover:bg-neutral-800/30 transition-colors"
          >
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="text-sm text-neutral-200 truncate">{p.name}</span>
                {p.unsafe && (
                  <ShieldAlert size={12} className="text-amber-500 shrink-0" title="Marked unsafe upstream" />
                )}
              </div>
              <div className="text-[10px] font-mono text-neutral-600 truncate">
                {p.categories.includes("All") ? "all categories" : p.categories.join(" · ").toLowerCase()}
              </div>
            </div>
            <Switch
              data-testid={`provider-switch-${p.id}`}
              checked={enabled.has(p.id)}
              onCheckedChange={() => onToggle(p.id)}
              className="data-[state=checked]:bg-cyan-500"
            />
          </label>
        ))}
      </div>

      <div className="px-4 py-3 border-t border-neutral-800">
        <label className="flex items-center gap-2.5 cursor-pointer">
          <Checkbox
            data-testid="hide-dead-checkbox"
            checked={hideDead}
            onCheckedChange={onHideDead}
            className="data-[state=checked]:bg-cyan-500 data-[state=checked]:border-cyan-500 border-neutral-700"
          />
          <span className="text-xs text-neutral-400">Hide dead torrents (0 seeders / peers)</span>
        </label>
      </div>
    </div>
  );
}
